// extracted by mini-css-extract-plugin
export default {"link":"i1PuYy3s"};